<div
  [style.--bg-mobile]="bgMobile"
  [style.--bg-desktop]="bgDesktop"
  class="bg d-flex position-relative"
  [appStoryblok]="_editable"
>
  <div
    class="positioner py-4 py-lg-5 container-xl z-1 d-flex flex-column h-100 w-100"
    [ngClass]="[
      aligny_mobile ?? '',
      aligny_desktop ?? '',
      alignx_mobile ?? '',
      alignx_desktop ?? '',
      'text-' + (alignx_mobile ?? '').split('-')[2] ?? '',
      'text-lg-' + (alignx_desktop ?? '').split('-')[3] ?? ''
    ]"
  >
    <div
      *ngIf="eyebrow"
      [ngClass]="[colour_mobile ?? '', colour_desktop ?? '']"
      class="h5"
    >
      {{ eyebrow }}
    </div>
    <h1
      *ngIf="headline"
      class="headline"
      [ngClass]="[
        display_font_face ? 'display-1' : '',
        colour_mobile ?? '',
        colour_desktop ?? ''
      ]"
    >
      {{ headline }}
    </h1>
    <div
      class="content w-50 d-none d-lg-block"
      *ngIf="content"
      [ngClass]="[colour_mobile ?? '', colour_desktop ?? '']"
      [storyblokRichText]="content"
    ></div>
    <div
      class="d-flex gap-2 flex-column flex-lg-row"
      [ngClass]="[alignx_mobile ?? '', alignx_desktop ?? '']"
    >
      <ndc-dynamic
        *ngFor="let blok of components ? actions : []"
        [ndcDynamicComponent]="components[blok.component]"
        [ndcDynamicInputs]="blok"
      >
      </ndc-dynamic>
    </div>
  </div>
  @defer (on idle){

  <img
    *ngIf="background_mobile?.filename"
    [ngSrc]="background_mobile.filename ?? ''"
    priority
    height="600"
    width="400"
    [loaderParams]="{ aspect: 0.6 }"
    class="bg d-lg-none"
  />
  <img
    [ngSrc]="background_desktop?.filename ?? background_mobile?.filename ?? ''"
    priority
    height="875"
    width="1400"
    [loaderParams]="{ aspect: 1.6 }"
    class="bg d-none d-lg-block"
  />
  } @placeholder {
  <div class="bg-secondary"></div>
  }
</div>
